<template>
  <div class="next-step-button">
    <button @click="nextStep" class="next-step">{{ $t("המשך") }}</button>
  </div>
</template>

<script>
export default {
  methods: {
    nextStep() {
      window.eventBus.$emit("nextStep");
    },
  },
};
</script>